<div fxLayout="column" fxLayoutAlign="center center" class="loader-container">
  <img class="loader" src="/assets/img/loader.gif" />
</div>
